module.exports = __webpack_public_path__ + "img/bank_18.2f929647.png";